var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',{attrs:{"title":_vm.detail.title || (_vm.isNotice ? '公告详情' : '教程详情')}},[(!_vm.isNotice && _vm.detail.category_name)?_c('div',{staticClass:"article-meta"},[_vm._v(_vm._s(_vm.detail.category_name))]):_vm._e(),_c('div',{staticClass:"agreement-content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }